/* Upakarna UTM persistence (Phase 6, brief section 7, measurement). Captures utm_*, gclid, fbclid, ttclid and the landing
   page on arrival, keeps them for the session (first touch wins, 30-day memory in localStorage as a fallback), and writes
   them to the cart as attributes once the cart has a line, so they reach the order under "Additional details" in Shopify
   admin and the order export. No personal data, no third-party calls. */
(function () {
  'use strict';
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'ttclid'];
  var STORE = 'upk_utm_v1';
  var TTL = 30 * 24 * 3600 * 1000;
  function read() { var raw = null; try { raw = sessionStorage.getItem(STORE) || localStorage.getItem(STORE); } catch (e) {} if (!raw) return null; try { var d = JSON.parse(raw); if (d && d.t && Date.now() - d.t < TTL) return d; } catch (e) {} return null; }
  function save(d) { var raw = JSON.stringify(d); try { sessionStorage.setItem(STORE, raw); } catch (e) {} try { localStorage.setItem(STORE, raw); } catch (e) {} }
  function capture() {
    var q; try { q = new URLSearchParams(window.location.search); } catch (e) { return read(); }
    var found = {}; var any = false;
    KEYS.forEach(function (k) { var v = q.get(k); if (v) { found[k] = String(v).slice(0, 120); any = true; } });
    var existing = read();
    if (!any) return existing;
    if (existing && existing.v && existing.v.utm_source && !q.get('utm_source')) return existing; /* first touch wins */
    var d = { t: Date.now(), v: found, landing: (window.location.pathname + window.location.search).slice(0, 200), ref: (document.referrer || '').slice(0, 200) };
    save(d); return d;
  }
  function attributesFor(d) {
    var a = {};
    Object.keys(d.v || {}).forEach(function (k) { a[k] = d.v[k]; });
    if (d.landing) a.landing_page = d.landing;
    if (d.ref) a.referrer = d.ref;
    return a;
  }
  var syncing = false;
  function sync() {
    var d = read(); if (!d || !d.v || !Object.keys(d.v).length || syncing) return;
    syncing = true;
    fetch((window.routes && window.routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) { syncing = false; return; }
        var want = attributesFor(d); var have = cart.attributes || {}; var missing = false;
        Object.keys(want).forEach(function (k) { if (have[k] !== want[k]) missing = true; });
        if (!missing) { syncing = false; return; }
        return fetch((window.routes && window.routes.cart_update_url || '/cart/update') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: want }) })
          .then(function () { syncing = false; });
      })
      .catch(function () { syncing = false; });
  }
  capture();
  /* After any add to cart: the theme's own events, Dawn's pub/sub, and a fetch hook as the fallback. */
  document.addEventListener('upk:cart:added', function () { setTimeout(sync, 400); });
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) { try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(sync, 400); }); } catch (e) {} }
  var of = window.fetch;
  if (of && !window.__upkUtmFetchHooked) {
    window.__upkUtmFetchHooked = true;
    window.fetch = function (u, o) {
      var p = of.apply(this, arguments);
      try { var s = String(u && u.url ? u.url : u); if (/\/cart\/(add|change|update)(\.js)?/.test(s) && !/attributes/.test(o && o.body ? String(o.body) : '')) p.then(function () { setTimeout(sync, 500); }); } catch (e) {}
      return p;
    };
  }
  document.addEventListener('submit', function (e) { var f = e.target; if (f && /\/cart\/add/.test(f.getAttribute('action') || '')) setTimeout(sync, 1500); }, true);
  setTimeout(sync, 1500);
})();
